import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-button__icon"
}
const _hoisted_2 = {
  key: 1,
  class: "base-button__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.autoTag), {
    class: _normalizeClass(["base-button", _ctx.additionalClasses]),
    to: _ctx.to,
    type: _ctx.buttonType,
    onClick: _ctx.onClick
  }, {
    default: _withCtx(() => [
      (_ctx.hasIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _renderSlot(_ctx.$slots, "icon")
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "to", "type", "onClick"]))
}